import React from 'react';
import StandardPriceGroup from './standardPriceGroup/StandardPriceGroup';
import OptionsSummary from './optionSummary/OptionSummary';
import Fees, { AboveTheLineFees } from './fees/Fees';
import Translate from '../../../core/translate/Translate';
import PackageSavings from './packageSavings/PackageSavings';
import TotalVehiclePrice from './totalVehiclePrice/TotalVehiclePrice';
import AboveTheLineIncentives from './aboveTheLineIncentives/AboveTheLineIncentives';
import BelowTheLineIncentives from './belowTheLineIncentives/BelowTheLineIncentives';
import NetPriceGroup from './NetPriceGroup';
import DealerInstalledAccessories from './dealerInstalledAccessories/DealerInstalledAccessories';
import TotalEmployeePriceGroup from './employeePriceGroup/TotalEmployeePriceGroup';
import TotalEmployeeDiscount from './employeePriceGroup/TotalEmployeeDiscount';
import FamilyFirstIneligibleMessage from './FamilyFirstIneligibleMessage';

const MathBoxWrapper = ({ children }) => (
  <div className="math-box">{children}</div>
);

const MathBox = ({ pricing, config, modelInfo, analyticsKey }) => {
  const { eligibleForInvoicePrice } = config;
  const { isFamilyFirst } = modelInfo;

  return (
    <MathBoxWrapper>
      <div className="math-box__header">
        <Translate value="summary" />
      </div>
      <StandardPriceGroup pricing={pricing} />
      <OptionsSummary
        config={config}
        pricing={pricing}
        analyticsKey={analyticsKey}
      />
      <Fees pricing={pricing} />
      {!!pricing.opdTotal && <PackageSavings pricing={pricing} />}
      <TotalVehiclePrice
        pricing={pricing}
        isFamilyFirst={modelInfo.isFamilyFirst || modelInfo.isFamilyFirstCA}
      />
      {isFamilyFirst && (
        <FamilyFirstIneligibleMessage
          eligibleForInvoicePrice={eligibleForInvoicePrice}
        />
      )}
      <TotalEmployeePriceGroup pricing={pricing} country={modelInfo.country} />
      {pricing.incentives.lines.length > 0 && (
        <AboveTheLineIncentives
          pricing={pricing}
          isFamilyFirst={modelInfo.isFamilyFirst || modelInfo.isFamilyFirstCA}
        />
      )}
      <AboveTheLineFees pricing={pricing} />
      <NetPriceGroup pricing={pricing} config={config} />
      {!modelInfo.isFamilyFirstCA && ( 
        <TotalEmployeeDiscount pricing={pricing} />
      )}
      <DealerInstalledAccessories config={config} pricing={pricing} />
      <BelowTheLineIncentives pricing={pricing} />
    </MathBoxWrapper>
  );
};
export default MathBox;
